/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conn_ClearInputs */

const cs_ebr_conn_clear = /** @type {(inputs: Ebr_Conn_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpojit`)
};

const en_ebr_conn_clear = /** @type {(inputs: Ebr_Conn_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnect`)
};

/**
* | output |
* | --- |
* | "Disconnect" |
*
* @param {Ebr_Conn_ClearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_clear = /** @type {((inputs?: Ebr_Conn_ClearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_ClearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_clear(inputs)
	return cs_ebr_conn_clear(inputs)
});